import { render, staticRenderFns } from "./SchoolListItem.vue?vue&type=template&id=bf1f77f6&scoped=true&"
import script from "./SchoolListItem.vue?vue&type=script&lang=js&"
export * from "./SchoolListItem.vue?vue&type=script&lang=js&"
import style0 from "./SchoolListItem.vue?vue&type=style&index=0&id=bf1f77f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1f77f6",
  null
  
)

export default component.exports